export function upperFirstLetterFilter() {
  "ngInject";
  return function (str) {return str && str.replace(/^(.)/, function (x) {return x.toUpperCase();});};
}